<mat-drawer-container>
  <mat-drawer
    [opened]="expanded"
    mode="side"
    position="end"
    [disableClose]="true"
    class="side-panel-contents"
  >
    <div class="side-panel-content">
      <div class="side-panel-header" *ngIf="!hasCustomHeader && headerInfo">
        <div class="side-panel-header-title">
          <h3>{{ headerInfo.title }}</h3>
          <span class="side-panel-actions">
            <mat-icon
              svgIcon="close"
              class="side-panel-close-button"
              (click)="closePanel()"
            ></mat-icon>
          </span>
        </div>
      </div>
      <ng-content select="[side-panel-header]"></ng-content>
      <ng-content select="[side-panel-body]"></ng-content>
    </div>
    <div class="side-panel-footer" (click)="expandedButtonClicked()">
      <span class="side-panel-actions">
        <mat-icon svgIcon="expand" class="side-panel-open-button"></mat-icon>
        <span class="side-panel-open-text">Expand</span>
      </span>
    </div>
  </mat-drawer>

  <mat-drawer-content>
    <ng-content select="[side-content]"></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
